import { useCmsStore } from "@/components/AppHooks";
import { CocktailDetailsMaster } from "./master";
import { CocktailDetailsSmirnoff } from "./smirnoff";
import { CocktailDetailsTanqueray } from "./tanqueray";
import { styleName } from "@/config/const";
import { TCocktailDetailProps } from "./type";
import Head from "next/head";

export function CocktailDetail(props: {
    component: Array<TCocktailDetailProps>
    searchParams: Record<string, string | null>
}) {
    const { storeConfig: { storeStyleName = styleName.Master } } = useCmsStore()!
    const pageProps = props.component.find((item) => item.storeStyleName === storeStyleName)!
    return (
        <>
            <Head>
                <title>My page title</title>
                <meta property="og:title" content="My page title" key="title" />
            </Head>
            {storeStyleName === styleName.Master && <CocktailDetailsMaster {...pageProps} searchParams={props.searchParams} />}
            {storeStyleName === styleName.SmirnoffKenya && <CocktailDetailsSmirnoff {...pageProps} searchParams={props.searchParams} />}
            {storeStyleName === styleName.Tanqueray && <CocktailDetailsTanqueray {...pageProps} searchParams={props.searchParams} />}
        </>
    );
}